import { Component } from '@angular/core';

@Component({
  selector: 'app-adminto',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {}
